import TabelaPeriodos from './tabelaperiodos';
import { DataAmigavel, TempoAmigavelAteHoje } from '@/shared/utils/datas';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { BiPrinter } from 'react-icons/bi';
import { SelectGenerico } from '@/shared/components/forms/SelectGenerico';
import { IconeDoTipoPeriodo } from '@/modules/business/periodo/Icones';
import imprimirDiv from '@/shared/utils/impressao';
import { Links } from '@/shared/constants/navegacao';
import { ReadDefensorResponseDto } from '@/api.types';
import { TipoPeriodoDescanso } from '../enums/tipo-periodo-descanso.enum';
import { toast } from 'react-toastify';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useParams } from 'react-router-dom';

export default function PeriodoIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const params = useParams();
  const id = params.id ? Number(params.id) : 0;

  const [defensorId, setDefensorId] = useState<ReadDefensorResponseDto>();
  const [defensores, setDefensores] = useState<ReadDefensorResponseDto[] | null>();

  useEffect(() => {
    EnumerateDefensores(0, 1000)
      .then((result) => {
        setDefensores(result.objects);
        if (
          result !== undefined &&
          result !== null &&
          result.objects.length > 0
        ) {
          setDefensorId(
            id > 0 ? result.objects.find((a) => a.id == id) : result.objects[0],
          );
        }
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  useEffect(() => {
    const href = defensorId ? Links.Acoes_Criar + '/' + defensorId.id : Links.Acoes_Index;
    setActions({ primary: { label: 'Cadastrar', href, onClick: () => { } } });
    return () => setActions({});
  }, [setActions, defensorId]);

  const defensoresOrdenados = useMemo(
    () =>
      [...(defensores ?? [])].sort((a, b) =>
        (a.pessoa?.nome ?? '').localeCompare(b.pessoa?.nome ?? '', 'pt-BR'),
      ),
    [defensores],
  );

  function GetAccordionItem(
    nome: string,
    titulo: string,
    tipo: TipoPeriodoDescanso,
  ) {
    const accordionId = `heading${nome}`;
    const accordionDiv = `collapse${nome}`;

    const printContainerId = `periodo-print-${nome}`;

    return (
      <Fragment>
        <h2 className="accordion-header d-flex align-items-stretch" id={accordionId}>
          <button
            className="accordion-button collapsed flex-grow-1"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${accordionDiv}`}
            aria-expanded="false"
            aria-controls={accordionDiv}
          >
            {IconeDoTipoPeriodo(tipo)}
            <span className="ms-2">{titulo}</span>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary border-0 rounded-0 d-flex align-items-center px-3"
            title="Imprimir tabela"
            aria-label={`Imprimir tabela de ${titulo}`}
            onClick={(e) => {
              e.stopPropagation();
              imprimirDiv(printContainerId, {
                titulo: defensorId?.pessoa?.nome ?? '',
                subtitulo: titulo,
              });
            }}
          >
            <BiPrinter size={18} aria-hidden />
          </button>
        </h2>
        <div
          id={accordionDiv}
          className="accordion-collapse collapse"
          aria-labelledby={accordionId}
        >
          <div className="accordion-body">
            <div id={printContainerId}>
              <TabelaPeriodos defensor={defensorId!} tipo={tipo} />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Cadastro de Ausências</h3>
          <span className="blockquote-footer pb-4 text-end">
            Férias, abonos, licenças e demais ausências dos defensores.
          </span>
        </div>
        <hr className="pb-4" />

        {/* Filtros */}
        <div className="col-auto">
          <label htmlFor="defensor" className="col-form-label">
            Defensor(a):
          </label>
        </div>
        <div className="col-md-4 col-lg-3">
          <SelectGenerico
            id="defensor"
            name="defensor"
            items={defensoresOrdenados}
            value={defensorId}
            onChange={(item) => item && setDefensorId(item)}
            getOptionLabel={(d) => d.pessoa?.nome ?? ''}
            getOptionValue={(d) => d.id!}
            isClearable={false}
          />
        </div>
        <div className="col-12 text-end">
          <span className="blockquote-footer">
            Admissão: {DataAmigavel(defensorId?.data_admissao)} (
            {TempoAmigavelAteHoje(defensorId?.data_admissao as unknown as Date)}) / Idade:{' '}
            {DataAmigavel(defensorId?.pessoa?.dataNascimento)} (
            {TempoAmigavelAteHoje(defensorId?.pessoa?.dataNascimento as unknown as Date)}).
          </span>
        </div>

        {/* Tabelas / Listas */}
        <div className="">
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              {GetAccordionItem('ferias', 'Férias', TipoPeriodoDescanso.Ferias)}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'folganatalicia',
                'Folga Natalícia',
                TipoPeriodoDescanso.FolgaNatalicia,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'abonotrabalhado',
                'Abono por Dia Trabalhado',
                TipoPeriodoDescanso.AbonoTrabalhado,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'abonoespecial',
                'Abono Especial',
                TipoPeriodoDescanso.AbonoEspecial,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'licencapremio',
                'Licença Prêmio',
                TipoPeriodoDescanso.LicencaPremio,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'licencaoutrosmotivos',
                'Licença Outros Motivos',
                TipoPeriodoDescanso.LicencaOutros,
              )}
            </div>
            {/* <div className="accordion-item">
							{GetAccordionItem("afastamentos", "Afastamentos", TipoPeriodoDescanso.Afastamento)}
						</div> */}
          </div>
        </div>
        <div className="col-12">
          <br />
          <br />
        </div>
      </div>
    </>
  );
}
